import React from 'react';
import { Link } from 'react-router-dom';
import { MONO } from '../../constants/fonts';

function SiteFooter() {
  return (
    <footer style={s.footer}>
      <span style={s.footerBrand}>
        <span style={{ color: '#3a3a3a' }}>DDH</span>
        <span style={{ color: '#9ca3af' }}>[</span>
        <span style={{ color: '#6b6b6b' }}>APPS</span>
        <span style={{ color: '#9ca3af' }}>]</span>
      </span>
      <span style={s.footerMeta}>
        <Link to="/privacypolicy" style={s.footerLink}>Privacy</Link>
        <span style={s.footerDot}>·</span>
        © {new Date().getFullYear()} DDHAPPS LTD.
      </span>
    </footer>
  );
}

const s = {
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: 8,
    padding: '20px 32px',
    borderTop: '1px solid #ebebeb',
    background: '#f9f9f7',
  },
  footerBrand: {
    fontFamily: MONO,
    fontSize: '0.8rem',
    fontWeight: 600,
    letterSpacing: '0.03em',
    userSelect: 'none',
  },
  footerMeta: { fontSize: '0.78rem', color: '#9ca3af' },
  footerLink: { color: '#6b7080', textDecoration: 'none' },
  footerDot: { margin: '0 8px' },
};

export default SiteFooter;
